import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getQuestions, 
  addQuestions as postQuestions, 
  updateQuestions as putQuestions, 
  deleteQuestions as removeQuestions,
  activateDeactivateQuestions as activateQuestions,

  questionOptions as questionOptionsApi,
  getScore,
  getSubTopic
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import axios from "axios";


// Fetch Table Column Names
export const fetchQuestionTableColumnNames = createAsyncThunk("questions/fetchTableColumnNames", async (question, thunkAPI) => {
    try {
      const response = await getHeaders(question); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Questions
export const fetchAllQuestions = createAsyncThunk("questions/fetchAll", async (question, thunkAPI) => {
    try {
      const response = await getQuestions(question); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Question
export const createQuestions = createAsyncThunk("questions/add", async (question, thunkAPI) => {  
    try {
        const response = await postQuestions(question);
        toast.success(response.message);
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Question
export const updateQuestions = createAsyncThunk("questions/update", async (question, thunkAPI) => {
    try {
        const response = await putQuestions(question);
        toast.success(response.message);
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Question
export const deleteQuestions = createAsyncThunk("questions/delete", async (question, thunkAPI) => {
    try {
        const response = await removeQuestions(question);
        toast.success(response.message);
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Active deactive Question 
export const activateDeactivateQuestions = createAsyncThunk("questions/activateDeactivate", async (question, thunkAPI) => {
  try {
    const response = await activateQuestions(question);
    toast.success(response.message);
    return response.data;
  } catch (error) {
    toast.error(error.message)
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Add Or Update Options
export const questionOptions = createAsyncThunk("questions/options", async (question, thunkAPI) => {  
    try {
        const response = await questionOptionsApi(question);
        toast.success(response.message);
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Questions
export const fetchAiQuestions = createAsyncThunk("aiQuestions/fetchAi", async (question, thunkAPI) => {
  try {
    
    const response = await axios.post('https://us-central1-yasa-21022022.cloudfunctions.net/GetQuestions', question); 

    toast.success(response.Message);
    const topic = response.Data.topic;
    const questionsWithTopic = response.Data.questions.map(q => ({
      ...q,
      topic 
    }));
    
    return questionsWithTopic;
  } catch (error) {
    console.log("error", error);
    
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Fetch All Score
export const fetchAllScore = createAsyncThunk("Score/fetchAll", async (thunkAPI) => {
  try {    
    const response = await getScore(); 
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});